import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withApollo } from 'react-apollo';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import CloseIcon from '@material-ui/icons/Close';
import AsyncPaginate from 'react-select-async-paginate';
import { getAsyncLookupOptionValue } from 'services/utils';
import { buildDeceasedNameAndDateOfDeath } from 'services/utils/bereavement';
import { apolloClientType } from 'types/apollo';
import { reactRefType } from 'types/common';
import { components } from 'react-select';
import styles from 'scss/main.scss';
import { getBereavements, getBereavement } from './queries.gql';


const customSelectStyles = {
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused ? styles.colorGreyUltraLight : styles.colorWhite,
    color: 'inherit',
  }),
  dropdownIndicator: provided => ({
    ...provided,
    padding: '4 0',
    color: 'rgba(0, 0, 0, 0.54)',
  }),
  clearIndicator: provided => ({
    ...provided,
    padding: 4,
    color: 'rgba(0, 0, 0, 0.54)',
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  valueContainer: provided => ({
    ...provided,
    padding: '6px 0',
  }),
  input: provided => ({
    ...provided,
    margin: 0,
  }),
  singleValue: provided => ({
    ...provided,
    marginLeft: 0,
    marginRight: 0,
  }),
  control: (provided, state) => {
    const focusedStyle = state.isFocused ? styles.colorOffWhite : 'inherit';
    return {
      'display': 'flex',
      'backgroundColor': state.hasValue ? 'inherit' : focusedStyle,
      '&:hover': {
        cursor: 'pointer',
      },
      '&:before': {
        'left': 0,
        'right': 0,
        'bottom': 0,
        'content': '"\\00a0"',
        'position': 'absolute',
        'transition': 'border-bottom-color 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
        'border-bottom': '1px solid',
        'borderBottomWidth': state.isFocused ? '2px' : '1px',
        'borderBottomColor': state.isFocused ? styles.colorHighlight : 'rgba(0, 0, 0, 0.42)',
        'pointer-events': 'none',
      },
    };
  },
  menu: provided => ({
    ...provided,
    marginTop: 0,
    paddingTop: 4,
    paddingBottom: 4,
  }),
};

const CustomClearIndicator = (props) => {
  const {
    getStyles,
    innerProps: { ref, ...restInnerProps },
  } = props;
  return (
    <div
      {...restInnerProps}
      ref={ref}
      style={getStyles('clearIndicator', props)}
    >
      <CloseIcon />
    </div>
  );
};

CustomClearIndicator.propTypes = {
  getStyles: PropTypes.func.isRequired,
  innerProps: PropTypes.shape({
    ref: reactRefType,
  }),
};

const CustomDropdownIndicator = props => (
  <components.DropdownIndicator {...props}>
    <ArrowDropDownIcon />
  </components.DropdownIndicator>
);

class BereavementLookupContainer extends Component {
  static propTypes = {
    client: apolloClientType.isRequired,
    label: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]),
    onChange: PropTypes.func.isRequired,
    overridezindex: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  getBereavementById = async (id) => {
    const { client, onChange } = this.props;
    const { data } = await client.query({
      query: getBereavement,
      variables: {
        id,
      },
    });
    onChange(data.bereavement);
  }

  getBereavements = async (term, prevResults, prevMetadata) => {
    const { client } = this.props;

    const lastCursor = (prevMetadata && prevMetadata.lastCursor) ? prevMetadata.lastCursor : null;

    const data = await client.query({
      query: getBereavements,
      variables: {
        pagination: {
          first: 15,
          after: lastCursor,
        },
        term: (term !== '') ? term : null,
      },
    });
    const { edges, pageInfo } = data.data.bereavements;
    const newResults = edges.map(({ node }) => ({
      label: buildDeceasedNameAndDateOfDeath(node),
      value: node,
    }));

    return {
      options: newResults,
      hasMore: pageInfo.hasNextPage,
      additional: {
        lastCursor: pageInfo.endCursor,
      },
    };
  }

  render() {
    const {
      label,
      overridezindex,
      value: propValue,
      onChange,
    } = this.props;

    if (typeof propValue === 'string') {
      this.getBereavementById(propValue);
    }

    const value = propValue && typeof propValue !== 'string' ? {
      label: buildDeceasedNameAndDateOfDeath(propValue),
      value: propValue,
    } : null;

    return (
      <AsyncPaginate
        id="bereavementLookup"
        value={value}
        onChange={changedValue => onChange(changedValue && changedValue.value)}
        placeholder={label}
        loadOptions={this.getBereavements}
        getOptionValue={option => getAsyncLookupOptionValue(option)}
        debounceTimeout={500}
        isClearable
        isSearchable
        styles={customSelectStyles}
        className={overridezindex && styles.o_select_override}
        components={{
          ClearIndicator: CustomClearIndicator,
          DropdownIndicator: CustomDropdownIndicator,
        }}
      />
    );
  }
}

export default withApollo(BereavementLookupContainer);
